<template>
    <ContentPage title="Комиссии - Покупатель">
        <div>
            <p>
                Если иное не согласовано в письменной форме или не указано в Особых условиях аукциона, Комиссии, подлежащие уплате покупателем
                компании Fleequid за покупку и продажу каждого отдельного транспортного средства, осуществленную через Маркетплейс или службы и
                системы купли-продажи Fleequid, составляют следующее:
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> без НДС</p>
            <p><strong>**</strong> плюс НДС, если применимо</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Пример 1:</p>
            <p>Цена присуждения: 6.000&nbsp;€ +&nbsp;НДС</p>
            <p>
                Комиссия, подлежащая уплате Fleequid Покупателем: <br class="md:hidden" />
                <span class="font-medium">
                    фиксированная сумма 250&nbsp;€ +&nbsp;(6.000&nbsp;€ * 8,75%) =
                    <span class="whitespace-nowrap">775&nbsp;€ +&nbsp;НДС</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Пример 2:</p>
            <p>Цена присуждения: 180.000&nbsp;€ +&nbsp;НДС</p>
            <p>
                Комиссия, подлежащая уплате Fleequid Покупателем: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(100.000&nbsp;€ * 8,75%) +&nbsp;(80.000&nbsp;€ * 3,75%) =
                    <span class="whitespace-nowrap">12.000&nbsp;€ +&nbsp;НДС</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
